<template>
    <div>
        <form-group label="Date on Receipt" name="date" :required="true">
            <datepicker v-model="expense.date" :max-date="maxDate"/>
        </form-group>

        <form-group label="Currency Used" name="currency" :required="true">
            <div class="select">
                <select v-model="expense.currency" id="currency" class="input">
                    <option :value="null" disabled>Select a currency</option>
                    <option v-for="currency in commonCurrencies">
                        {{currency.currency}}
                    </option>
                    <option disabled>––</option>
                    <option v-for="name in sortedCurrencies">
                        {{name}}
                    </option>
                </select>
            </div>
        </form-group>

        <div class="flex flex-wrap">
            <div class="w-full md:w-1/2">
                <form-group label="Amount including VAT" name="amount.0" :required="true">
                    <div class="flex">
                        <input type="number"
                               min="0"
                               step="1"
                               placeholder="0"
                               class="input text-right amount-int-input"
                               v-model="expense.amount[0]"
                               pattern="[0-9]{*}">
                        <div class="input-group-addon">,</div>
                        <input type="number" min="0" step="1" class="input w-16" v-model="expense.amount[1]"
                               pattern="([0-9]|[0-9])">
                    </div>
                    <div class="help-text text-red" v-if="hasError('amount')" v-html="getError('amount')"></div>
                </form-group>
            </div>
        </div>

        <form-group :label="`Expense inside ${employee ? employee.country : ''}?`" name="domestic" :required="true">
            Yes <input type="radio" :value="1" v-model="expense.domestic" class="mr-4">
            No <input type="radio" :value="0" v-model="expense.domestic">
        </form-group>

        <div class="flex flex-wrap" v-if="expense.domestic === 1">
            <div class="w-full md:w-1/2">
                <form-group label="VAT" name="vat.0" :required="true">
                    <div class="flex">
                        <input type="number"
                               min="0"
                               step="1"
                               placeholder="0"
                               class="input text-right amount-int-input"
                               v-model="expense.vat[0]"
                               pattern="[0-9]{*}">
                        <div class="input-group-addon">,</div>
                        <input type="number" min="0" step="1" class="input w-16" v-model="expense.vat[1]"
                               pattern="([0-9]|[0-9])">
                    </div>
                    <div class="help-text text-red" v-if="hasError('vat')" v-html="getError('vat')"></div>
                </form-group>
            </div>
        </div>

        <form-group label="Attachments" name="attachments" :required="true">
            <file-upload :url="fileUploadUrl"
                         :deleteUrl="fileDeleteUrl"
                         v-model="expense.attachments"
                         @activeFileUpload="$emit('activeFileUpload', $event)">
            </file-upload>
        </form-group>

    </div>
</template>

<script>

import {mapState} from "vuex";
import Form from './form';
import InteractsWithDates from '@/mixins/InteractsWithDates';
import FileUpload from "@/components/DragUpload";

export default {
    mixins: [Form, InteractsWithDates],

    components: {
        FileUpload
    },

    props: ['value', 'fileUploadUrl', 'fileDeleteUrl'],

    data() {
        return {
            expense: {
                ...{
                    amount: [0, 0],
                    currency: null,
                    domestic: null,
                    vat: [0, 0],
                }, ...this.value,
            },
            currencies: [],
        }
    },

    mounted() {
        this.fetchSources();
    },

    computed: {
        ...mapState(['employee']),

        commonCurrencies() {
            return this.currencies.filter(currency => currency.hasOwnProperty('common'))
        },

        sortedCurrencies() {
            let currencies = this.currencies.filter(currency => !currency.hasOwnProperty('common'));
            const list = _.sortBy(currencies, 'currency').reverse();
            return _.sortBy(list, 'currency').reverse().map(item => item.currency);
        }
    },

    methods: {

        fetchSources() {
            if (!this.currencies.length) {
                this.$api('expenses').get('/sources?type=currencies')
                    .then(({data: {data}}) => {
                        this.currencies = data;
                    })
            }
        },
    }
}
</script>

<style lang="scss" scoped>
input[type=number] {
    -moz-appearance: textfield;
}

.amount-int-input {
    min-width: 0;
}
</style>
